import React from 'react';
import RDVButtonComponent from './RDVButtonComponent'

function SportifComponent (){
	return (
		<div id="sportif-section" className="partenaires">
		  <h2>Ostéopathie du sportif</h2>
			<div className="container">
      	<div className="row">
        	<div className="col-md-12">
					<div className="article-content">
						<p>
							Que ce soit dans le milieu professionnel ou dans le milieu amateur, votre corps est
							soumis aux traumatismes et micro-traumatismes causés par la pratique de votre sport,
							ce qui peut perturber son équilibre général. L’ostéopathe saura détecter les zones
							contraintes afin de rétablir l’harmonie globale du corps et de vous aider à éviter les blessures.
						</p>

						<p>
							Les articulations, les muscles, les ligaments sont soumis à des contraintes biomécaniques importantes
							lors de la pratique sportive et un déséquilibre peut s’installer pouvant aller de la simple
							contracture à la douleur chronique.
						</p>

						<p>
							L’athlète dans sa carrière sportive peut se blesser. Dans le cadre de l’entorse de la cheville par
							exemple, il peut s’installer dans le temps une instabilité de l’articulation.
							Cette instabilité peut avoir une répercussion sur la posture sur le long terme comme une gêne à la
							marche sur le court terme (boiterie) . La performance est donc altérée et cela peut engendrer des
							compensations du corps.
						</p>

						<p>
							Dans le cadre de la tendinite fréquemment rencontrée, l’athlète est amené au cours de ses compétitions
								ou de ses entraînements à répéter des efforts pouvant entraîner des douleurs autour de
								l’articulation. Prenons par exemple le cas du tennis. Le tennis-elbow est la tendinite le
								plus souvent rencontrée dans les cabinets d’ostéopathie. L’ostéopathe met en place un traitement
								qui peut soulager la douleur et permettre à l’athlète de reprendre son activité.
						</p>

						<p>
							L’ostéopathie chez le sportif améliore vos performances en traitant les véritables causes des
							douleurs limitant la pratique de l’activité sportive, en améliorant le potentiel et la puissance
							musculaire, la souplesse articulaire et la capacité respiratoire. Dans le cadre de sa formation en
							soins sportifs, l’ostéopathe va permettre de mettre en place un vrai suivi sportif, il est en mesure
							de vous conseiller sur l’alimentation adaptée à votre niveau de sport, aux étirements à effectuer
							avant et après votre sport en expliquant leurs intérêts.
						</p>

						<p>
							Dans le monde du sport l’ostéopathe ne peut travailler seul, il travaille en étroite
							collaboration avec des kinés, des podologues par la mise en place des semelles orthopédiques
							pour les marathoniens par exemple. Retrouvez les différents partenariats pour une meilleure
							prise en charge afin d’augmenter les performances de l’athlète.
						</p>
					</div>

				</div>
			</div>
		</div>

		<RDVButtonComponent/>

	  </div>
	)
}

export default SportifComponent;
